import React, { useEffect, useState } from 'react';

let counter = 0;

export const SvgScopeWrap: React.FC<{ children: React.ReactElement<SVGElement> }> = ({ children }) => {
  const [ref, setRef] = useState<SVGElement | null>(null);

  useEffect(() => {
    if (!(ref instanceof SVGElement)) {
      return;
    }
    counter++;
    const allClips = ref.querySelectorAll<SVGClipPathElement>('clipPath');
    const allLinearGradients = ref.querySelectorAll<SVGLinearGradientElement>('linearGradient');
    const allRadialGradients = ref.querySelectorAll<SVGLinearGradientElement>('radialGradient');
    const allMasks = ref.querySelectorAll<SVGLinearGradientElement>('mask');
    [...allClips, ...allLinearGradients, ...allRadialGradients, ...allMasks].forEach((el) => {
      const id = el.getAttribute('id');
      const clipTargets = [
        ...ref.querySelectorAll(`[clip-path="url(#${id})"]`),
        ...ref.querySelectorAll(`[clip-path="url('#${id}')"]`),
      ];
      const fillTargets = [
        ...ref.querySelectorAll(`[fill="url(#${id})"]`),
        ...ref.querySelectorAll(`[fill="url('#${id}')"]`),
      ];
      const maskTargets = [
        ...ref.querySelectorAll(`[mask="url(#${id})"]`),
        ...ref.querySelectorAll(`[mask="url('#${id}')"]`),
      ];
      if (clipTargets.length || fillTargets.length || maskTargets.length) {
        // specify id uniquely on the page
        el.setAttribute('id', `${id}__${counter}`);
      }
      if (clipTargets.length) {
        clipTargets.forEach((t) => t.setAttribute('clip-path', `url(#${id}__${counter})`));
      }
      if (fillTargets.length) {
        fillTargets.forEach((t) => t.setAttribute('fill', `url(#${id}__${counter})`));
      }
      if (maskTargets.length) {
        maskTargets.forEach((t) => t.setAttribute('mask', `url(#${id}__${counter})`));
      }
    });
  }, [ref]);

  return React.cloneElement(children, { ref: setRef });
};
